export const VARIAVEIS = [
  { key: "{nome_cliente}", desc: "Nome do tutor" },
  { key: "{nome_pet}", desc: "Nome do pet" },
  { key: "{nome_pets}", desc: "Nomes dos pets selecionados" },
  { key: "{artigo_pet}", desc: '"do" ou "da" (sexo do pet)' },
  { key: "{dias_ausente}", desc: "Dias sem visita" },
  { key: "{nome_loja}", desc: "Nome da loja" },
  { key: "{telefone_loja}", desc: "Telefone da loja" },
];

export const CRM_PET_TABS = [
  // { value: "ALL", label: "Todos" },
  { value: "ABSENT", label: "Ausentes" },
  { value: "NO_PRODUCT", label: "Produtos" },
  { value: "NO_ADDITIONAL", label: "Adicionais" },
  { value: "POTENTIAL_SUBSCRIBER", label: "Avulsos" },
];

const COMMON_COLUMNS = {
  tutor: { key: "tutor", label: "Tutor", size: "minmax(150px, 1fr)", sortKey: "customerName" },
  pet: { key: "pet", label: "Pet", size: "minmax(105px, 1fr)", sortKey: "petName" },
  type: { key: "type", label: "Tipo", size: "minmax(180px, 230px)" },
  absence: { key: "absence", label: "Ausência", size: "100px", sortKey: "absenceDays" },
  lastAppointment: { key: "lastAppointment", label: "Última visita", size: "105px", sortKey: "lastAppointmentAt" },
  nextAppointment: { key: "nextAppointment", label: "Próxima visita", size: "115px", sortKey: "nextAppointmentAt" },
  subscriber: { key: "subscriber", label: "Assinante", size: "90px", sortKey: "subscriptionStatus" },
  contact: { key: "contact", label: "Contato", size: "90px", sortKey: "latestContactAt" },
  actions: { key: "actions", label: "Ações", size: "155px" },
};

const CATEGORY_COLUMNS = {
  RACAO: { key: "category:RACAO", label: "Ração", size: "105px" },
  TAPETE: { key: "category:TAPETE", label: "Tapete", size: "105px" },
  PETISCOS: { key: "category:PETISCOS", label: "Petiscos", size: "105px" },
  ANTI_PULGAS: { key: "category:ANTI_PULGAS", label: "Anti pulgas", size: "115px" },
  HIDRATACAO: { key: "category:HIDRATACAO", label: "Hidratação", size: "100px" },
  CORTE_UNHAS: { key: "category:CORTE_UNHAS", label: "Corte de unhas", size: "110px" },
  ESCOVACAO: { key: "category:ESCOVACAO", label: "Escovação de dentes", size: "140px" },
};

const DEFAULT_COLUMNS = [
  COMMON_COLUMNS.tutor,
  COMMON_COLUMNS.pet,
  COMMON_COLUMNS.type,
  COMMON_COLUMNS.absence,
  COMMON_COLUMNS.lastAppointment,
  COMMON_COLUMNS.nextAppointment,
  COMMON_COLUMNS.subscriber,
  COMMON_COLUMNS.contact,
  COMMON_COLUMNS.actions,
];

export const CRM_PET_VIEW_CONFIG = {
  ALL: {
    // minWidth: 1195,
    columns: DEFAULT_COLUMNS,
  },
  ABSENT: {
    minWidth: 1195,
    columns: [
      COMMON_COLUMNS.tutor,
      COMMON_COLUMNS.pet,
      COMMON_COLUMNS.absence,
      COMMON_COLUMNS.lastAppointment,
      COMMON_COLUMNS.nextAppointment,
      COMMON_COLUMNS.subscriber,
      COMMON_COLUMNS.contact,
      COMMON_COLUMNS.actions,
    ],
  },
  NO_PRODUCT: {
    minWidth: 1545,
    columns: [
      COMMON_COLUMNS.tutor,
      COMMON_COLUMNS.pet,
      CATEGORY_COLUMNS.RACAO,
      CATEGORY_COLUMNS.TAPETE,
      CATEGORY_COLUMNS.PETISCOS,
      CATEGORY_COLUMNS.ANTI_PULGAS,
      COMMON_COLUMNS.subscriber,
      COMMON_COLUMNS.absence,
      COMMON_COLUMNS.lastAppointment,
      COMMON_COLUMNS.nextAppointment,
      COMMON_COLUMNS.contact,
      COMMON_COLUMNS.actions,
    ],
  },
  NO_ADDITIONAL: {
    minWidth: 1545,
    columns: [
      COMMON_COLUMNS.tutor,
      COMMON_COLUMNS.pet,
      CATEGORY_COLUMNS.HIDRATACAO,
      CATEGORY_COLUMNS.CORTE_UNHAS,
      CATEGORY_COLUMNS.ESCOVACAO,
      COMMON_COLUMNS.subscriber,
      COMMON_COLUMNS.absence,
      COMMON_COLUMNS.lastAppointment,
      COMMON_COLUMNS.nextAppointment,
      COMMON_COLUMNS.contact,
      COMMON_COLUMNS.actions,
    ],
  },
  POTENTIAL_SUBSCRIBER: {
    minWidth: 1405,
    columns: [
      COMMON_COLUMNS.tutor,
      COMMON_COLUMNS.pet,
      COMMON_COLUMNS.subscriber,
      { key: "frequency", label: "Frequência", size: "115px" },
      COMMON_COLUMNS.absence,
      { key: "lastSubscription", label: "Última assinatura", size: "145px" },
      { ...COMMON_COLUMNS.lastAppointment, label: "Último agendamento", size: "155px" },
      { ...COMMON_COLUMNS.nextAppointment, label: "Próximo agendamento", size: "160px" },
      COMMON_COLUMNS.contact,
      COMMON_COLUMNS.actions,
    ],
  },
};

export function getCrmPetViewConfig(rule = "ALL") {
  return CRM_PET_VIEW_CONFIG[rule] || CRM_PET_VIEW_CONFIG.ALL;
}

/*
 * Colunas que a engrenagem NAO deixa esconder: sem tutor e pet a linha nao
 * identifica ninguem, e sem acoes nao da para fazer nada com ela. Esconder
 * qualquer uma das tres transformaria a tabela num enigma.
 */
export const COLUNAS_FIXAS = new Set(["tutor", "pet", "actions"]);

export function colunasOcultaveis(rule) {
  return getCrmPetViewConfig(rule).columns.filter(
    (coluna) => !COLUNAS_FIXAS.has(coluna.key)
  );
}
